import React from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import CallEndIcon from '@mui/icons-material/CallEnd';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';

import CallTimer from 'components/CallScribe/Dialer/CallTimer';
import { formatPhoneE164ToDisplay } from 'components/CallScribe/Recents/recentsHelpers';
import useWindowStyles from 'components/CallScribe/Window/windowStyles';

export interface ILiveCallBarProps {
  contactName?: string;
  toNumber: string;
  live: boolean;
  answeredAtMs?: number;
  isMuted: boolean;
  onToggleMute: () => void;
  onEnd: () => void;
  onBackToCall: () => void;
}

const LiveCallBar: React.FC<ILiveCallBarProps> = ({
  contactName,
  toNumber,
  live,
  answeredAtMs,
  isMuted,
  onToggleMute,
  onEnd,
  onBackToCall,
}) => {
  const classes = useWindowStyles();
  const who = contactName !== undefined && contactName.trim().length > 0
    ? contactName.trim()
    : formatPhoneE164ToDisplay(toNumber);

  return (
    <div className={classes.liveBar}>
      <span className={classes.liveDot} />
      <button
        type="button"
        className={classes.liveLabelZone}
        onClick={onBackToCall}
        aria-label={`Back to call with ${who}`}
      >
        <span className={classes.liveWho}>{who}</span>
        {typeof answeredAtMs === 'number' ? (
          <CallTimer
            running
            compact
            sinceMs={answeredAtMs}
            className={classes.liveTimer}
          />
        ) : (
          <span className={classes.liveTimer}>Calling…</span>
        )}
      </button>
      <span className={classes.liveActions}>
        <Tooltip title={isMuted ? 'Unmute' : 'Mute'}>
          <IconButton
            size="small"
            aria-label={isMuted ? 'Unmute' : 'Mute'}
            onClick={onToggleMute}
          >
            {isMuted ? <MicOffIcon fontSize="small" /> : <MicIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
        <Tooltip title="End call">
          <IconButton size="small" aria-label="End call" className={classes.endButton} onClick={onEnd}>
            <CallEndIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Button size="small" className={classes.backToCall} onClick={onBackToCall}>
          Back to call
        </Button>
      </span>
    </div>
  );
};

export default LiveCallBar;
